import { useLocation, useSearchParams } from 'react-router-dom';
import { MobileQueryRoutes, MobileQuerySearchParams } from '@constants/mobile-query';
export var useMobileQuery = function () {
    var location = useLocation();
    var searchParams = useSearchParams()[0];
    var hasPathname = Object.values(MobileQueryRoutes).some(function (route) {
        return location.pathname.includes(route);
    });
    var hasSearchParam = Object.values(MobileQuerySearchParams).some(function (param) { return searchParams.get(param.key) === param.value; });
    return hasPathname && hasSearchParam;
};
